import React from 'react'
import Paper from 'material-ui/Paper'
import { styles } from './Styles'
import { themeColors } from '../../styles/theme'

const Termini = () => (
  <Paper style={styles.paper}>
    <h4 style={styles.titles}>Termini e condizioni d'uso</h4>
    <h6 style={styles.subtitles}>
      Informazioni generali e oggetto del servizio
    </h6>
    <p>
      Il Sito internet swapick.com (di seguito chiamato anche semplicemente “Sito”) è di proprietà della Società Wegreen s.r.l. (di seguito chiamata semplicemente Società), corrente in Via del Casalino, 13 – 24121 Bergamo (Italia) offre ai propri utenti la possibilità di comprare, vendere e permutare (scambiare, barattare) beni, in qualsiasi momento, da qualunque postazione internet, anche mobile, con o senza il pagamento di una somma di denaro a titolo di corrispettivo della cessione.
    </p>
    <p>
      La Società è l'unica e legittima proprietaria del Sito e del software ad essi associato e di tutti i diritti di utilizzo che ne discendono.
    </p>
    <p>
      La maggior parte delle informazioni disponibili su swapick.com è aggiornata in tempo reale ed è di proprietà della Società oppure è stata concessa in licenza d'uso dagli utenti o da terzi.
    </p>
    <p>
      L'accesso al servizio di inserimento degli oggetti è consentito all'utente esclusivamente tramite il completamento della procedura di registrazione al Sito.
      <br />
      La gestione delle transazioni richiede, in seguito, l’immissione obbligatoria di nome, cognome e indirizzo di residenza.
    </p>
    <p>
      Per  favorire gli utenti, l’inserimento degli oggetti sul Sito avviene anche attraverso una procedura automatica. Attraverso il programma di affiliazione ad Amazon.com, Inc. o Società affiliate, swapick.com offre cataloghi di immagini predefinite, descrizioni e specifiche di prodotti e fornisce all’utente anche la possibilità di acquistarli.
    </p>
    <p style={{ marginBottom: 60 }}>
      Swapick.com cerca di fornire dati affidabili, ma non può garantire che i cataloghi siano sempre precisi ed aggiornati.
    </p>
    <h6 style={styles.subtitles}>Condizioni di registrazione</h6>
    <p>
      Per diventare un membro di swapick.com ed utilizzare i relativi servizi, è necessario leggere ed accettare tutti i termini e le condizioni contenute sia nel presente documento che in quello relativo alla tutela della privacy e ai cookie.
    </p>
    <p>
      I servizi offerti dal Sito potranno essere utilizzati solo da persone maggiorenni (che abbiano compiuto il diciottesimo anno d’età), che siano in grado di stipulare contratti legalmente vincolanti ai sensi della legge applicabile.
    </p>
    <p>
      Tali servizi non potranno, pertanto, essere utilizzati da persone minori degli anni 18.
    </p>
    <p>
      Le persone di età inferiore a 18 anni potranno utilizzare questo servizio solo ed esclusivamente sotto la supervisione dei propri genitori o tutori legali.
    </p>
    <p>
      Qualora l’utente minorenne violi il presente contratto e le condizioni ivi contenute, la responsabilità graverà sui soggetti che esercitino la patria potestà o - in loro assenza - sui soggetti tenuti a vigilare sul minore.
    </p>
    <p>
      Il presente accordo acquista efficacia con l’accettazione, da parte dell’utente, di dette condizioni, al termine della procedura di registrazione che verrà convalidata a mezzo di una notifica inviata all'indirizzo e-mail dell'utente. I successivi accessi al servizio di pubblicazione e gestione degli annunci saranno consentiti tramite l'uso della propria username (o email) e della password.
    </p>
    <p>
      L’account che ciascun utente crea su swapick.com (compreso il feedback) e l’ID utente non potranno essere trasferiti o venduti a terzi.
    </p>
    <p>Ogni utente può avere un solo account.</p>
    <p>
      Non sono consentiti più di tre account attribuibili allo stesso indirizzo di residenza e/o domicilio e quindi allo stesso nucleo familiare.
    </p>
    <p>
      Swapick.com ha il diritto di limitare eventuali abusi, qualora lo ritenga necessario, per proteggere gli utenti da frodi o dal rischio di frodi.
    </p>
    <p>
      La registrazione di un account con un nominativo (nome, cognome e indirizzo) diverso dal dichiarante, fittizio o reale, è espressamente vietata e può essere perseguita penalmente nelle opportune sedi.
    </p>
    <p>
      Il presente accordo potrebbe subire delle modifiche in qualsiasi momento che verranno comunicate agli utenti mediante la pubblicazione delle stesse direttamente sul Sito e l’invio di una email informativa per presa visione.
    </p>
    <p>
      L’utente che non dovesse accettare tali modifiche sopravvenute, sarà libero di recedere entro 30 giorni dalla pubblicazione comunicandolo tramite il modulo contatti del sito.
      <br />
      In caso di silenzio da parte dell’utente si intendono accettate dopo 30 giorni dalla pubblicazione.
    </p>
    <p style={{ marginBottom: 60 }}>
      L'utente acconsente a ricevere periodicamente sul proprio indirizzo di posta elettronica informazioni di servizio relative al Sito (Newsletter, aggiornamenti, etc...).
      <br />
      L'utente acconsente a ricevere notifiche push sul proprio dispositivo mobile.
    </p>
    <h6 style={styles.subtitles}>Responsabilità della Società</h6>
    <p>
      La Società e gli utenti agiscono in piena autonomia ed indipendenza.
    </p>
    <p>
      Le presenti condizioni d'uso non fanno sorgere tra le sopra indicate parti alcun rapporto di collaborazione, agenzia, associazione, intermediazione o lavoro subordinato.
    </p>
    <p>
      Swapick.com si limita a facilitare le transazioni tra gli utenti, ma non è coinvolto nello svolgimento delle stesse.
    </p>
    <p>
      La Società non ha alcun obbligo di controllo o responsabilità su qualità, vizi, sicurezza o legalità degli articoli venduti e/o scambiati, sulla veridicità o accuratezza delle inserzioni o sulla capacità degli utenti di vendere, acquistare, permutare e fare proposte, né può assicurare che un utente sia effettivamente in grado di portare a termine una transazione.
    </p>
    <p>
      La Società non trasferisce la proprietà degli oggetti  da un utente all’altro e nessuna parte del presente contratto può modificare le disposizioni in materia di diritto di proprietà ex artt. 832 ss., in base ai quali viene trasferita la proprietà di un bene mobile al momento della ricezione dello stesso.
    </p>
    <p>
      L'utente esonera la Società da qualsiasi responsabilità derivante da contenuti, attività o inattività e/o annunci pubblicati da altri utenti.
    </p>
    <p>
      La Società non può garantire la veridicità dei dati personali forniti dagli utenti al momento della registrazione sul Sito e per tale ragione non risponde per eventuali danni, diretti e indiretti, subiti da ciascun utente a causa dell'utilizzo di dati falsi da parte di uno o più utenti.
    </p>
    <p>
      La Società non risponde dell'andata a buon fine o meno delle transazioni per mezzo del Sito e non risponde di alcuna condotta, sia essa attiva o omissiva degli utenti.
    </p>
    <p>
      Eventuali danni che possano derivare al sistema informatico degli utenti dall'uso del Sito a causa di azioni od omissioni di altri utenti non possono essere attribuiti alla Società.
    </p>
    <p>
      L'utente riconosce che la Società non è un "intermediario" nel senso tradizionale e giuridico del termine. Il Sito è semplicemente una piattaforme web dove chiunque può essere messo nella condizione di vendere, acquistare e permutare (barattare) oggetti, in qualsiasi momento, da qualunque postazione internet, anche mobile, e in qualsiasi luogo.
    </p>
    <p>
      L'utente può, utilizzando i servizi del Sito, corrispondere con altri utenti e altri promotori pubblicitari e pertanto può ricevere materiale pubblicitario della cui provenienza e contenuto la Società non si assume alcuna responsabilità. La Società declina ogni responsabilità sulle trattative e sulle conseguenti transazioni commerciali derivanti da tali promozioni pubblicitarie.
    </p>
    <p>
      La pubblicazione degli annunci su swapick.com avviene anche attraverso una procedura automatica. Ne deriva che gli annunci vengono pubblicati senza che il Sito e la Società siano obbligati ad operare una verifica sul contenuto, sull’accuratezza e sulla veridicità degli stessi.
    </p>
    <p>
      La Società declina, pertanto, ogni responsabilità relativa alla validità delle inserzioni.
    </p>
    <p>
      Inoltre la procedura automatica di pubblicazione degli annunci, nonostante gli espressi divieti previsti dalle presenti condizioni d'uso del Sito, potrebbe portare alla consultazione di informazioni dal contenuto non gradito o adatto ad un pubblico adulto, in relazione  alle quali la Società e il Sito declinano ogni responsabilità. L'utente ha comunque la facoltà di segnalare eventuali annunci che non rispettino le regole previste dalle presenti condizioni d'uso del Sito  tramite il modulo contatti.
    </p>
    <p>
      La Società non garantisce l'accesso continuo e ininterrotto al Sito e ai propri servizi, che può essere condizionato da cause o fattori al di fuori del proprio controllo.
    </p>
    <p>
      Di conseguenza, nei limiti previsti dal Codice del Consumo e da altre leggi vigenti, la Società esclude qualsiasi garanzia, termine e condizione implicita.
    </p>
    <p>
      La Società non è in alcun modo responsabile per le perdite economiche o per i danni patrimoniali e non patrimoniali, né per danni diretti, indiretti o conseguenti derivanti dall’utilizzo del proprio Sito e dei relativi servizi.
    </p>
    <p>
      Tutte le informazioni personali saranno trattate ed utilizzate dalla Società nel rispetto delle regole di riservatezza e di sicurezza previste dalla legge, così come indicato nell’Informativa sulla Privacy a tal fine prevista (par. Informativa sulla Privacy).
    </p>
    <p>
      La Società e il Sito declinano ogni responsabilità per eventuali ritardi nella consegna dei beni oggetto delle transazioni e/o nel caso di eventuali danni agli imballaggi e conseguenti ammanchi e/o per eventuali danni subiti durante il trasporto di tali beni.
    </p>
    <p style={{ marginBottom: 60 }}>
      La Società si riserva il diritto di modificare, sospendere o interrompere - temporaneamente o permanentemente - il Sito. In tal caso, la Società non è in alcun modo responsabile verso gli utenti o verso terzi per eventuali danni derivanti dalla modifica, sospensione o interruzione del Sito o di una parte di esso.
    </p>
    <h6 style={styles.subtitles}>Responsabilità dell’utente</h6>
    <p>
      L'utente è responsabile del contenuto delle informazioni pubblicate su swapick.com tramite l'utilizzo della propria username e password.
    </p>
    <p>
      Le credenziali d’accesso sono strettamente personali ed il loro uso è consentito, nei termini previsti dalle presenti condizioni d'uso del Sito, solo all'utente che abbia provveduto alla registrazione.
    </p>
    <p>
      L'utente si impegna a mantenere la riservatezza della password ed è l’unico responsabile di tutte le attività connesse al suo uso, anche se da lui non autorizzate. La condivisione di password di account con altre persone è una violazione di questo accordo e potrebbe comportare la chiusura dell'account.
    </p>
    <p>
      Se si ritiene che il proprio account non sia più sicuro (per esempio, in caso di smarrimento, furto o divulgazione non autorizzata o uso improprio dell’ID, password, carta di credito o altro) occorre segnalare immediatamente il problema a swapick.com, al fine di evitare eventuali abusi e responsabilità.
    </p>
    <p>
      Con l'accettazione delle presenti condizioni d'uso del Sito, l’utente autorizza la Società a processare le Informazioni Personali fornite ai sensi dell'Informativa sulla Privacy (Par. Informativa sulla Privacy).
      <br />
      L'utente dovrà mantenere aggiornate le Informazioni Personali e garantirne la veridicità, completezza e precisione.
      <br />
      L'utente acconsente inoltre esplicitamente che tali informazioni possano essere divulgate nel caso in cui pervengano alla Società - ai sensi della legge vigente – esplicite richieste di comunicazione da parte di un’Autorità statale o giudiziaria.
    </p>
    <p>
      Attraverso Swapick.com l’utente viene a conoscenza delle username degli altri utenti e delle rispettive provincie di residenza; inoltre dopo aver concluso una transazione il Sito informa con una email circa i dati necessari per la spedizione degli oggetti (nome, cognome e indirizzo di residenza).
    </p>
    <p>
      Ciascun utente accetta che altri utenti possano venire a conoscenza dei propri dati personali e si impegna a trattare i dati personali degli altri utenti, raccolti attraverso l’utilizzo del Sito, nel pieno rispetto del D.Lgs. 196/2003 e di tutta la normativa vigente in materia, obbligandosi a manlevare e tenere indenne la Società e le sue collegate e/o controllate da qualsiasi danno, azione, pretesa, spesa, sanzione derivante dalla violazione della presente garanzia. In particolare, ciascun utente si impegna ad utilizzare i dati personali comunicati dagli altri utenti per mezzo del Sito, ivi inclusi gli indirizzi di posta elettronica, esclusivamente per finalità inerenti al Sito ed entro i limiti ivi previsti.
    </p>
    <p>
      Accettando il presente accordo, l'utente si obbliga a tenere indenne e a manlevare la Società, le sue collegate e/o controllate, le filiali, i dipendenti e collaboratori, da qualsiasi richiesta o controversia, comprensiva di ogni spesa o onere, ivi incluse eventuali spese legali, intentata da qualsiasi terza parte in merito all’uso del Sito da parte dell'utente, alla violazione da parte dell'utente delle presenti condizioni d'uso del Sito, alla violazione da parte dell'utente della username e della password di altri utenti o di qualsiasi diritto di proprietà intellettuale e industriale o altro diritto di cui è titolare la Società o terzi.
    </p>
    <p>
      L’utente è l'unico responsabile delle foto, profili, messaggi, note, testi, informazioni, elenchi e altri contenuti che ha caricato o pubblicato sul Sito o tramite il Sito.
    </p>
    <p>
      Le informazioni e le attività sul Sito non dovranno in alcun modo:
    </p>
    <ul>
      <li>(a) essere false, inesatte o fuorvianti;</li>
      <li>
        (b) essere fraudolenti o riguardanti la vendita e/o la permuta di oggetti contraffatti o rubati;
      </li>
      <li>
        (c) violare il copyright della Società o di terzi, brevetti, marchi, segreti commerciali o altri diritti di proprietà intellettuale e industriale o diritti di pubblicità;
      </li>
      <li>
        (d) violare il diritto alla riservatezza e alla protezione delle persone rispetto al trattamento dei loro dati personali (privacy);
      </li>
      <li>
        (e) violare alcuna legge, statuto, ordinanza o regolamento vigente;
      </li>
      <li>
        (f) essere illecite, oscene, calunniose, diffamatorie, offensive della morale corrente, lesive dei diritti altrui, incitanti all’odio ed alla discriminazione razziale o religiosa, che incoraggino azioni criminose o suscettibili di far sorgere responsabilità civile o violare in altro modo leggi o regolamenti locali, statali, nazionali o internazionali;
      </li>
      <li>(g) essere oscene o avere contenuti pornografici;</li>
      <li>
        (h) contenere virus, Trojan horse, worm o altri programmi del computer che potrebbero danneggiare, interferire, intercettare o espropriare qualsiasi sistema, dati o informazioni personali;
      </li>
      <li>
        (i) puntare direttamente o indirettamente, per includere descrizioni di merci o servizi che sono vietate ai sensi del presente accordo;
      </li>
      <li>
        (l) causare danni di qualsiasi genere alla Società e al Sito;
      </li>
      <li>
        (m) causare un'interruzione o sospensione totale o parziale del Sito.
      </li>
    </ul>
    <p>
      Quando l’utente fornisce a Swapick.com dei contenuti, concede a quest’ultimo una licenza d'uso perpetua, irrevocabile, senza limiti territoriali, a titolo gratuito e trasferibile (a più livelli) dei diritti d'autore, dei diritti di pubblicazione e dei diritti sulle banche dati di cui è titolare in relazione a tali contenuti, in qualsiasi formato già esistente o futuro.
    </p>
    <p style={{ marginBottom: 60 }}>
      Se l’utente sceglie di includere, nelle sue inserzioni, contenuti estratti dai cataloghi accetta di non attribuire la responsabilità di imprecisioni nei cataloghi ai fornitori degli stessi, al Sito e alla Società. I cataloghi potrebbero contenere materiale protetto dal diritto d'autore, marchi commerciali o altri diritti di proprietà intellettuale e industriale. L’utente può utilizzare i cataloghi esclusivamente a scopo informativo o per effettuare inserzioni sul Sito. Non può utilizzare il contenuto dei cataloghi violando diritti di terzi.
    </p>
    <p>
      L'utente non può pubblicare annunci pubblicitari e/o di promozione personale.
    </p>
    <p>
      L'utente si obbliga a non alterare, direttamente o tramite terzi, in alcun modo i servizi forniti dal Sito .
    </p>
    <p>
      L'utente si obbliga a non interferire con l'uso ed il godimento da parte di un altro utente del Sito.
    </p>
    <p>
      L’utente non potrà intraprendere azioni volte a destabilizzare il sistema di feedback del Sito.
    </p>
    <p>
      L’utente non potrà copiare, modificare o diffondere il contenuto del Sito o i diritti di proprietà intellettuale e industriale e i marchi registrati della Società o di terzi; oppure copiare o raccogliere in qualsiasi modo informazioni sugli utenti del Sito, compresi gli indirizzi email senza il loro consenso.
    </p>
    <p>
      Accettando il presente accordo, l’utente si impegna a non usare programmi software o altri meccanismi automatici o manuali per copiare o accedere alle pagine web del Sito o al loro contenuto senza l’autorizzazione della Società espressa in forma scritta.
    </p>
    <p>
      L'utente acconsente a non disassemblare o eseguire qualsiasi opera di studio del software del Sito per alcun motivo, o permettere ad un terzo di farlo.
    </p>
    <p>
      L’Utente è tenuto a completare tutte le operazioni che ha accettato e avviato.
    </p>
    <p>
      <strong>
        Tutti gli articoli devono essere in condizioni accettabili e, possibilmente, funzionanti e ancora utilizzabili
      </strong>
      {' '}
      (dichiarandolo qualora non lo fossero).
    </p>
    <p>
      L’eventuale smarrimento o danneggiamento durante il trasporto del bene oggetto della transazione non è di responsabilità dell’utente inviante. Rimane, invece, ferma la responsabilità di quest’ultimo nel caso di eventuali vizi o difetti del bene scambiato non dichiarati in origine.
    </p>
    <p>
      <strong>
        Tutti gli articoli devono essere originali, non sono accettate copie contraffatte.
        {' '}
      </strong>
      In caso contrario sarebbe una violazione non solo perseguibile a norma di legge, ma anche delle regole di swapick.com con conseguente sospensione dell’account.
    </p>
    <p>
      <strong>
        Nelle transazioni di scambio l'utente con la fascia di affidabilità più bassa si impegna a spedire l'oggetto per primo.
      </strong>
      {' '}
      In caso contrario sarebbe in violazione delle regole di swapick.com e il suo account potrebbe essere sospeso. Informazioni aggiuntive sono esplicitate all’interno del Sito alla pagina "Guida alla Sicurezza".
    </p>
    <p>
      L’ Utente può attribuire liberamente un valore in Euro al proprio oggetto.
    </p>
    <p>
      <strong>
        Gli articoli illegali sono proibiti su swapick.
      </strong>
      {' '}
      Inoltre, è vietato vendere cose che possono arrecare danni fisici o morali a qualcuno, e cose regolate dalla legge, ad esempio oggetti che non possono essere venduti a persone che non sono in possesso di licenza.
    </p>
    <p>
      Ecco alcuni esempi di
      {' '}
      <strong>oggetti e annunci proibiti</strong>
      :
    </p>
    <ul>
      <li>
        Articoli che violano marchi e diritti d’autore altrui (es. prodotti contraffatti come borse ecc.);
      </li>
      <li>Pubblicità;</li>
      <li>
        Foto e testi contenenti riferimenti ad altri siti web, app o negozi;
      </li>
      <li>
        Annunci in violazione delle buone maniere, della legge e delle restrizioni legali;
      </li>
      <li>
        Annunci di multilevel marketing e referral marketing;
      </li>
      <li>
        Offerte di lavoro o richieste di personale al di sotto dei 14 anni;
      </li>
      <li>
        Offerte contenenti numeri telefonici con costi estremamente elevati (tentativi di frode);
      </li>
      <li>
        Offerte aventi lo scopo di promuovere pagine /mi piace o nuovi follower sui social network;
      </li>
      <li>
        Offerte riguardanti prodotti o prestazioni sessuali;
      </li>
      <li>
        Foto, titoli o descrizioni che trasmettono una falsa impressione del contenuto del servizio;
      </li>
      <li>
        Qualsiasi tipo di arma o strumento atto ad offendere, qualificato tale ai sensi della L. 18 aprile 1975 n. 110 e del Regio Decreto 18 giugno 1931, n. 773 (" Testo unico delle Leggi di Pubblica Sicurezza "), ivi comprese le armi da guerra e da collezione, i giocattoli trasformabili in armi e le armi inidonee e non catalogate;
      </li>
      <li>Documenti d'identità o tesserini identificativi;</li>
      <li>
        Titoli di stato, azioni, obbligazioni e prodotti finanziari in genere, valute - anche virtuali;
      </li>
      <li>Tabacchi e sigarette elettroniche;</li>
      <li>Materiale pornografico o volgare;</li>
      <li>
        Preparati medici e qualunque genere di sostanze stupefacenti e psicotrope;
      </li>
      <li>
        Biglietti o abbonamenti per spettacoli, manifestazioni o viaggi ancora fruibili, palestre, servizi digitali, o comunque qualsiasi biglietto o abbonamento personale e non cedibile;
      </li>
      <li>
        Prodotti falsi o contraffatti, incluse schede per pay TV e telefonia;
      </li>
      <li>
        Copie illegali di brani musicali, film, libri, videogiochi, software e altri beni soggetti al diritto d’autore;
      </li>
      <li>
        Consolle per videogiochi modificate e altri dispositivi elettronici modificati, articoli o servizi di modifica che consentono di aggirare i sistemi di protezione (DRM);
      </li>
      <li>Alcool;</li>
      <li>
        Animali vivi, pellicce di animali in via di estinzione o altre parti di animali in via di estinzione, come ad esempio i prodotti in avorio;
      </li>
      <li>Banche dati e dati personali;</li>
      <li>Beni provenienti da Paesi soggetti ad embargo;</li>
      <li>Carte di credito o debito;</li>
      <li>
        Cataloghi di vendita e oggetti non in tuo possesso (“drop-shipping”);
      </li>
      <li>
        Generi alimentari deperibili e senza una data di scadenza;
      </li>
      <li>Dispositivi per lo scassinamento;</li>
      <li>
        Documenti governativi, documenti di transito e documenti di identità;
      </li>
      <li>
        Lotterie, roulette e concorsi a premi (nemmeno in maniera indiretta, per esempio comperando uno dei tuoi oggetti);
      </li>
      <li>Materiale offensivo;</li>
      <li>Materiale per adulti;</li>
      <li>
        Materiali pericolosi. Alcuni esempi: Coltelli e oggetti affilati, petardi e altri materiali esplosivi o infiammabili;
      </li>
      <li>Oggetti rubati o senza codice seriale;</li>
      <li>Pedopornografia in ogni forma;</li>
      <li>
        Piante e semi. Puoi vendere piante e semi, a patto che siano legali nel Paese in cui vivi e dove li spedisci. Come venditore, ti assumi pienamente questa responsabilità;
      </li>
      <li>
        Prodotti richiamati dalle aziende e tolti dal mercato perché difettosi o potenzialmente pericolosi per il consumatore;
      </li>
      <li>
        Proprietà artistiche, archeologiche e storiche, pubbliche o statali;
      </li>
      <li>Resti e parti umane;</li>
      <li>Tabacco;</li>
      <li>Valute e francobolli contraffatti;</li>
      <li style={{ marginBottom: 60 }}>
        Codici, buoni acquisto e sconto, buoni regalo, punti fedeltà, buoni vacanza e altri beni non materiali se nominativi o con indicazione “non cedibile a terzi”.
      </li>
    </ul>
    <h6 style={styles.subtitles}>
      Tariffe e Servizi a pagamento
    </h6>
    <p>
      L'utilizzo del Sito è gratuito. Determinati servizi tuttavia possono essere a pagamento e soggetti al pagamento di alcune tariffe (vedi pagina “servizi aggiuntivi”). L'Utente potrà visionare ed accettare tali tariffe in base alle condizioni che verranno comunicate prima di accedere a detti servizi. Le tariffe sono espresse in crediti (eCoin) e/o in Euro e potranno essere di volta in volta soggette a modifiche. Eventuali modifiche delle regole relative alle nostre tariffe verranno pubblicate sul sito. In caso di promozioni o nuovi servizi, potremmo modificare temporaneamente le nostre tariffe; queste modifiche avranno efficacia dal momento in cui la promozione o il nuovo servizio verrà comunicato.
    </p>
    <p>
      I prezzi sono espressi in Euro e comprendono l'Imposta sul Valore aggiunto (I.V.A) vigente per la categoria merceologica di appartenenza.
    </p>
    <p>
      Il pagamento del prezzo dovrà essere corrisposto in anticipo, al momento della stipulazione del contratto, mediante l'utilizzo di carta di credito, carte prepagate o PayPal.
    </p>
    <p>
      Swapick.com, al momento della conclusione del contratto avente ad oggetto l'erogazione dei servizi a pagamento, ha la facoltà di comunicare all'Utente che la gestione del processo dei pagamenti del corrispettivo dei servizi, nonché la successiva emissione e recapito del conseguente documento fiscale, verrà effettuata da un proprio commissionario e/o, comunque, da parte di un soggetto terzo a cui sia stato affidato specifico incarico.
    </p>
    <p>
      Resta inteso che il trattamento dei dati personali dell'Utente avverrà comunque in piena conformità alle finalità espresse nell'informativa privacy di Swapick.com, e, comunque, nel rispetto delle regole di riservatezza e di sicurezza previste dalla legge.
    </p>
    <p>
      L’acquisto dei crediti (eCoin) avviene attraverso la piattaforma di pagamento Paypal, con carta di credito o con il proprio account Paypal.
    </p>
    <p>
      La Società non trattiene i dati delle carte di credito e non ha alcun accesso a tali informazioni durante la procedura di pagamento.
    </p>
    <p>
      La Società non è responsabile in caso di errori, frodi, smarrimento, furto, sostituzione d’identità o altri problemi riguardanti l’utilizzo di carte di credito e/o connessi alla procedura di pagamento online.
    </p>
    <p>
      Sul Sito l’Utente può visualizzare in ogni momento il valore totale dei crediti (eCoin) posseduti.
    </p>
    <p>
      Swapick.com non prevede per l’Utente la possibilità di rivendere crediti (eCoin) a fronte di denaro al Sito e/o ad altri utenti.
    </p>
    <p>
      La Società può sospendere o chiudere l'account, se ha il sospetto che l’Utente sia impegnato in attività fraudolente in connessione con il Sito che interferiscano con il corretto funzionamento del sistema dei crediti.
    </p>
    <p style={{ marginBottom: 60 }}>
      Informazioni aggiuntive sui crediti sono esplicitate all’interno del Sito.
    </p>
    <h6 style={styles.subtitles}>Annullamento del Servizio</h6>
    <p>
      La Società si riserva il diritto di inviare all’utente un avviso, sospendere l’utente a tempo determinato o indeterminato, interrompendo la fornitura dei servizi nel caso di:
    </p>
    <ul>
      <li>
        (a) violazioni alle presenti condizioni d'uso del Sito;
      </li>
      <li>
        (b) impossibilità da parte della Società di verificare l'autenticità delle informazioni fornite in sede di registrazione o durante l'utilizzo dei servizi del Sito;
      </li>
      <li>
        (c) compimento di azioni che possano comportare danni economicamente rilevanti o responsabilità civile e/o penale a carico della Società, di altri utenti o di terzi.
      </li>
      <li>
        Qualora la condotta dell'utente non fosse conforme a quanto quivi previsto, la Società si riserva il diritto di bloccare il suo account, nonché di rifiutare ogni e qualsiasi futura richiesta da parte dell'utente di utilizzo dello stesso.
      </li>
      <li>
        L'utente riconosce e accetta che la Società può cancellare o rimuovere, anche senza preavviso, qualsiasi contenuto del Sito, per qualsiasi motivo o senza motivo, che violi il presente accordo o che potrebbe risultare offensivo, illegale o che possa violare i diritti, danneggiare o minacciare la sicurezza degli utenti, della Società stessa o di terzi. Nel caso in cui si verifichi una delle situazioni sopradette la Società si riserva di decidere in merito all’annullamento del servizio.
      </li>
      <li style={{ marginBottom: 60 }}>
        La Società può sospendere o chiudere l'account, se ha il sospetto che l’utente sia impegnato in attività fraudolente in connessione con il Sito. Questo include, inter alios, la creazione di account fasulli o il mancato riconoscimento della consegna di un oggetto quando in realtà è stato ricevuto.
      </li>
    </ul>
    <h6 style={styles.subtitles}>
      Recesso unilaterale dell’utente
    </h6>
    <p style={{ marginBottom: 60 }}>
      L'utente può interrompere l'uso dei servizi e recedere dal presente contratto in qualsiasi momento mediante la procedura di cancellazione dal Sito. Al riguardo, si precisa che, ai fini della sicurezza della piattaforma e degli utenti che la utilizzano, qualora l’utente disattivi il proprio account di accesso al Sito, tutti i suoi dati personali, ivi inclusi quelli relativi al proprio account (siano essi messaggi, proposte di permuta e informazioni di ogni genere) potrebbero non essere cancellati, bensì continuare a risiedere all’interno della banca dati del Sito, ma senza essere resi pubblici.
    </p>
    <h6 style={styles.subtitles}>Controversie</h6>
    <p>
      La Società persegue le frodi nella misura massima di legge, e non si assume alcuna responsabilità per qualsiasi attività fraudolenta commessa dagli utenti.
    </p>
    <p>
      La Società si riserva di assumere le opportune iniziative giudiziarie sia in sede civile che penale, a tutela dei propri diritti e dei diritti di terzi.
    </p>
    <p>
      Il Tribunale di Bergamo sarà competente, in via non esclusiva, a dirimere ogni controversia riguardante le presenti condizioni d'uso del Sito ed i rapporti dalle stesse regolati.
    </p>
  </Paper>
)

export default Termini



// WEBPACK FOOTER //
// ./src/common/Infotext/Termini.js